export class VitalsSummaryModel {

    fastingBloodSugar: string = "-"
    beforeMealsBloodSugar: string = "-"
    postMealsBloodSugar: string = "-"
    insulinTotalDailyDose: string = "-"
}